import { CheckIcon } from '@phosphor-icons/react';
import { css, html } from 'react-strict-dom';
import { Color, Style } from 'src/constants';
import { color } from 'src/constants/color.css';

import RadioButton from './RadioButton';
import Text from './Text';
import { Spacer } from '.';

type Props = {
  children: React.ReactNode;
  selected?: boolean;
  showRadio?: boolean;
  onClick?: () => void;
};

export default function DropdownMenuItem({
  children,
  selected,
  showRadio = true,
  onClick,
}: Props) {
  return (
    <html.button
      style={[Style.row, Style.alignCenter, styles.item]}
      onClick={onClick}
    >
      {showRadio && <RadioButton selected={selected} />}
      <Text
        typeface="body.regular"
        color="neutral100"
        style={showRadio ? Style.fill : undefined}
        textAlign="left"
      >
        {children}
      </Text>
      {!showRadio && selected && (
        <>
          <Spacer fill />
          <CheckIcon size={16} color={Color.accent} />
        </>
      )}
    </html.button>
  );
}

const styles = css.create({
  item: {
    width: '100%',
    gap: 8,
    paddingInline: 16,
    paddingBlock: 12,
    borderWidth: 0,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: color.neutral20,
    backgroundColor: '#fff',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    ':hover': {
      backgroundColor: color.neutral10,
    },
  },
});
